<!-- Template -->
<template>
    <div class="col-1" :class="{hidden:hidden}" id="hospital-navigation">
        <ul class="nav nav-tabs level-1">
            <li class="nav-item square" v-for="hospital in hospitals" :key="hospital.id" :title="hospital.locationName">
                <router-link
                    class="nav-link"
                    :class="{ active: active && active.id === hospital.id }"
                    :to="{ name: 'Hospital', params: { hospital: hospital.id } }"
                >
                    <span>H</span>
                    <span
                        v-if="hospital.supportTicketsCount"
                        class="badge white-border"
                    >{{hospital.supportTicketsCount}}</span>
                </router-link>
                <!-- <p  @dblclick.prevent="hospitalNameDialog.show(hospital.locationName, hospital.id)">{{hospital.locationName}}</p> -->
                <p>{{hospital.locationName}}</p>
            </li>
        </ul>
    </div>
    <!-- <hospital-name ref="hospitalNameDialog"></hospital-name> -->
</template>

<!-- Script -->

<script>
    // import HospitalName from "@/components/Dialogs/HospitalName";

    export default {
        name: "HospitalNavigation",
        props: ["active", "hospitals"],

         data() {
            return {
                hidden: true,
                //changeHospitalNameIsOn: false,
                //selectedHospitalName: '',
                //selectedHospitalID: ''
            };
        },

        methods: {
            // showHospitalNameDialog(name, id) {
            //     this.selectedHospitalName = name;
            //     this.selectedHospitalID = id;
            //     this.changeHospitalNameIsOn = true;
            // },

            // closeHospitalNameDialog(){
            //     this.changeHospitalNameIsOn = false;
            // },

            // hospitalNameChanged(value) {
            //     this.selectedHospitalName = value;
            // }

            show(){
                this.hidden = false;
            },
            hide(){
                this.hidden = true;
            }
        
        }


        /*
        components: {
            HospitalName
        },

        computed: {
            
            hospitalNameDialog() { 
                return this.$refs.hospitalNameDialog; 
            }
        },

       

        
        */
    };
</script>



